import { render, staticRenderFns } from "./AliasViewDialog.vue?vue&type=template&id=5f62821e&"
import script from "./AliasViewDialog.vue?vue&type=script&lang=js&"
export * from "./AliasViewDialog.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports